// ITER291 — Compact period-filter bar for the Loyalty analytics
// dashboard. Behaviour mirrors the Marketing PeriodFilterBar so
// operators see the same interaction pattern across modules, but this
// version is intentionally standalone (no cross-module import) so the
// two dashboards can evolve independently.
//
// Preset ids match `services/marketing_dashboard.resolve_period()` on
// the backend: current | previous | mtd | ytd | last3 | last6 | last12
// | custom. Custom exposes month + year dropdowns.
import React from 'react';

export const LOYALTY_PERIOD_PRESETS = [
  { id: 'current',  label: 'Current Month' },
  { id: 'previous', label: 'Previous' },
  { id: 'mtd',      label: 'MTD' },
  { id: 'ytd',      label: 'YTD' },
  { id: 'last3',    label: 'Last 3M' },
  { id: 'last6',    label: 'Last 6M' },
  { id: 'last12',   label: 'Last 12M' },
  { id: 'custom',   label: 'Custom' },
];

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun',
                'Jul','Aug','Sep','Oct','Nov','Dec'];

export function LoyaltyPeriodFilterBar({ period, setPeriod,
                                          year, month, setYm,
                                          scopeLabel }) {
  const now = new Date();
  const currentYear = now.getFullYear();
  const years = [currentYear + 1, currentYear, currentYear - 1, currentYear - 2];

  return (
    <div className="flex flex-wrap items-center gap-2"
         data-testid="loyalty-period-filter-bar">
      <div className="text-[11px] uppercase tracking-widest text-gray-500 mr-1">
        Period
      </div>
      {LOYALTY_PERIOD_PRESETS.map((p) => {
        const active = p.id === period;
        return (
          <button
            key={p.id}
            onClick={() => setPeriod(p.id)}
            data-testid={`loyalty-period-btn-${p.id}`}
            className={`text-xs px-2.5 py-1 rounded-full border transition ${
              active
                ? 'bg-slate-900 text-white border-slate-900'
                : 'bg-white text-gray-700 border-gray-300 hover:border-slate-500'
            }`}
          >
            {p.label}
          </button>
        );
      })}

      {period === 'custom' && (
        <div className="flex items-center gap-2 ml-1">
          <select
            className="h-7 text-xs border rounded px-2"
            value={month || (now.getMonth() + 1)}
            onChange={(e) => setYm(year || currentYear, Number(e.target.value))}
            data-testid="loyalty-period-custom-month"
          >
            {MONTHS.map((m, i) => (
              <option key={m} value={i + 1}>{m}</option>
            ))}
          </select>
          <select
            className="h-7 text-xs border rounded px-2"
            value={year || currentYear}
            onChange={(e) => setYm(Number(e.target.value), month || (now.getMonth() + 1))}
            data-testid="loyalty-period-custom-year"
          >
            {years.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>
      )}

      {scopeLabel && (
        <div className="text-xs text-slate-500 ml-1"
             data-testid="loyalty-period-scope-label">
          Showing: <span className="font-medium text-slate-700">{scopeLabel}</span>
        </div>
      )}
    </div>
  );
}
